//------------------------------------------------------------------------
// About page jump link nav
//------------------------------------------------------------------------
"use strict";
import ExpandToggle from "@threespot/expand-toggle";

export default class SubNav {
  constructor(el) {
    this.el = el;

    // Mobile nav toggle setup
    //---------------------------------
    // NOTE: Breakpoint must match $bp-small in _page-header.scss
    this.mediaQueryList = window.matchMedia("(min-width: 768px)");
    this.toggle = this.el.querySelector(".Subnav-about-toggle");

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.destroyToggle();
      } else {
        this.initToggle();
      }
    });

    // Init on load
    if (!this.mediaQueryList.matches) {
      this.initToggle();
    }
  }

  initToggle() {
    this.toggleExpand = new ExpandToggle(this.toggle);
  }

  destroyToggle() {
    this.toggleExpand.destroy();
  }
}

const init = () => {
  let subnav = document.querySelector(".Subnav-about");

  if (subnav) {
    new SubNav(subnav);
  }
};

// Init on initial page load
init();

